/**
 * Gets the active element in the document or shadow root (if an element is provided, and it's in the shadow DOM).
 */
function getActiveElement(element, options) {
  if (element == null) {
    return document.activeElement;
  }
  const rootNode = element.getRootNode(options) ?? document;
  return rootNode.activeElement;
}
function getRelatedTargetWithFallback(e) {
  return e.relatedTarget ?? getActiveElement(e.currentTarget);
}
const HTMLProps = ['id', 'style'];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function pickHTMLProps(props) {
  return Object.fromEntries(Object.entries(props).filter(([key]) => HTMLProps.includes(key) || key.startsWith('data-') || key.startsWith('aria-')));
}

export { getActiveElement, getRelatedTargetWithFallback, pickHTMLProps };
